<label>Not In Variant</label>
<app-autocomplete-field
    [controlName]="controlName"
    [config]="autoCompleteFieldOptions"
>
</app-autocomplete-field>